import React from 'react';

class RequireMarkComponent extends React.Component {
  render() {
    return <span className="text-danger">*</span>;
  }
}

export default RequireMarkComponent;
